<template>
  <footer>
    <div class="container-fluid d-flex flex-wrap justify-content-between">
      <nav>
        <ul class="footer-menu">
          <li>
            <!-- <router-link :to="{ path: '/dashboard' }">Dashboard</router-link> -->
            <a href="http://www.pcsuniq.com" target="_blank">
              <img
                class="image-logo"
                width="350"
                height="70"
                src="../../../assets/data/pcsuniq-logo-basic.png"
                alt="PCS UNIQ WEBSITE"
              />
            </a>
          </li>
        </ul>
      </nav>
      <div class="copyright">
        <p>
          Data collected by: Dr. Ágoston Hamar, Dr. Kristóf Filipánits, -
          Supervised by: Dr. Katalin Gombos
        </p>
      </div>
      <div class="copyright link-pcs">
        <span> &copy; {{ year }} All rights reserved. </span>
        <span
          >Created and designed by
          <a class="link-pcs" href="http://www.pcsuniq.com/" target="_blank"
            >PCS uniq</a
          >
        </span>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style scoped>
.copyright {
  margin-top: 1.5rem !important;
  padding-left: 1rem !important;
}
.link-pcs {
  font-size: 18px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}
.copyright p {
  font-size: 18px;
}
@media (max-width: 1600px) {
  .link-pcs {
    font-size: 16px;
  }
  .copyright p {
    font-size: 16px;
  }
  .image-logo {
    width: 325px;
    height: 65px;
  }
}

@media (max-width: 1400px) {
  .link-pcs {
    font-size: 14px;
  }
  .copyright p {
    font-size: 14px;
  }
  .image-logo {
    width: 250px;
    height: 65px;
  }
}
@media (max-width: 1200px) {
  .link-pcs {
    font-size: 12px;
  }
  .copyright p {
    font-size: 12px;
  }
  .image-logo {
    width: 200px;
    height: 60px;
  }
}
</style>
